/**
 * Test IDs for QA automation.
 */
export const testIds = {
  chipTagsInputAddTags: "chip-tags-input-add-tags",
} as const;
